import BaseValidator from "./BaseValidator";

const passwordValidator = Object.create(BaseValidator);

passwordValidator.isValid = function passwordValidatorIsValid(input) {
  return input.length > 9;
};

export default passwordValidator.init();
